import { __decorate } from 'tslib';
import { ElementRef, Input, HostListener, Directive, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
var ClickOnKeyDirective_1;
let ClickOnKeyDirective = ClickOnKeyDirective_1 = class ClickOnKeyDirective {
    constructor(el) {
        this.el = el;
        this._keyIds = ClickOnKeyDirective_1.DEFAULT_KEY_IDS;
        this.stopPropagation = true;
        this.preventDefault = true;
    }
    set keyIds(value) {
        this._keyIds = value ? value : ClickOnKeyDirective_1.DEFAULT_KEY_IDS;
    }
    get keyIds() { return this._keyIds; }
    keyPressed(e) {
        var _a;
        if (e.currentTarget === ((_a = this.el) === null || _a === void 0 ? void 0 : _a.nativeElement)) {
            if (this.keyIds.indexOf(e.key) !== -1 || this.keyIds.indexOf(e.code) !== -1) {
                if (this.stopPropagation)
                    e.stopPropagation();
                if (this.preventDefault)
                    e.preventDefault();
                e.currentTarget.dispatchEvent(new Event('click'));
            }
        }
    }
    ;
};
ClickOnKeyDirective.ɵfac = function ClickOnKeyDirective_Factory(t) { return new (t || ClickOnKeyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ClickOnKeyDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ClickOnKeyDirective, selectors: [["", "egovClickOnKey", ""]], hostBindings: function ClickOnKeyDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keypress", function ClickOnKeyDirective_keypress_HostBindingHandler($event) { return ctx.keyPressed($event); });
    } }, inputs: { stopPropagation: "stopPropagation", preventDefault: "preventDefault", keyIds: ["egovClickOnKey", "keyIds"] } });
ClickOnKeyDirective.ctorParameters = () => [
    { type: ElementRef }
];
ClickOnKeyDirective.DEFAULT_KEY_IDS = ['Enter', 'Space'];
__decorate([
    Input('egovClickOnKey')
], ClickOnKeyDirective.prototype, "keyIds", null);
__decorate([
    Input()
], ClickOnKeyDirective.prototype, "stopPropagation", void 0);
__decorate([
    Input()
], ClickOnKeyDirective.prototype, "preventDefault", void 0);
__decorate([
    HostListener('keypress', ['$event'])
], ClickOnKeyDirective.prototype, "keyPressed", null);

let ClickOnKeyModule = class ClickOnKeyModule {
};
ClickOnKeyModule.ɵfac = function ClickOnKeyModule_Factory(t) { return new (t || ClickOnKeyModule)(); };
ClickOnKeyModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ClickOnKeyModule });
ClickOnKeyModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClickOnKeyDirective, [{
        type: Directive,
        args: [{
                selector: '[egovClickOnKey]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { stopPropagation: [{
            type: Input
        }], preventDefault: [{
            type: Input
        }], keyIds: [{
            type: Input,
            args: ['egovClickOnKey']
        }], keyPressed: [{
            type: HostListener,
            args: ['keypress', ['$event']]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClickOnKeyModule, [{
        type: NgModule,
        args: [{
                declarations: [ClickOnKeyDirective],
                exports: [ClickOnKeyDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ClickOnKeyModule, { declarations: [ClickOnKeyDirective], exports: [ClickOnKeyDirective] }); })();

/*
 * Public API Surface of angular-click-on-key
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ClickOnKeyModule, ClickOnKeyDirective as ɵa };

